export default __webpack_public_path__ + "media/src/assets/images/Vector-6dcc2ac4e7e26dd24ba1ea96e6dd3262.png";